/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { IReadOnlyListOfMonthlyCoveragePlanSummaryDto } from './iReadOnlyListOfMonthlyCoveragePlanSummaryDto.schema';

export const PagedResultOfMonthlyCoveragePlanSummaryDto = zod.object({
  "items": zod.lazy(() => IReadOnlyListOfMonthlyCoveragePlanSummaryDto).optional(),
  "pageNumber": zod.number().optional(),
  "pageSize": zod.number().optional(),
  "totalItems": zod.number().optional(),
  "totalPages": zod.number().optional(),
  "hasNextPage": zod.boolean().optional(),
  "hasPreviousPage": zod.boolean().optional()
});

export type PagedResultOfMonthlyCoveragePlanSummaryDto = zod.input<typeof PagedResultOfMonthlyCoveragePlanSummaryDto>;
export type PagedResultOfMonthlyCoveragePlanSummaryDtoOutput = zod.output<typeof PagedResultOfMonthlyCoveragePlanSummaryDto>;
